import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiResponseModel } from '../../../models/core/api-response.model';
import { SimpleItemModel } from '../../../models/simple-item.model';
import { MetaResource } from '../../../services/resources/meta.resource';
import { RolesResource } from '../../../services/resources/roles.resource';

@Component({
    selector: 'sl-users-partial-form',
    templateUrl: './users-partial-form.component.html',
    styleUrls: ['./users-partial-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersPartialFormComponent implements OnInit {
    formGroup = input.required<UntypedFormGroup>();

    roles: Observable<ApiResponseModel<SimpleItemModel[]>>;
    readonly metaResource = inject(MetaResource);

    private readonly rolesResource = inject(RolesResource);

    ngOnInit(): void {
        this.roles = this.rolesResource.getAll().pipe(
            map(r => {
                const items: SimpleItemModel[] = [];

                r.value.forEach(i =>
                    items.push(
                        new SimpleItemModel({
                            id: i.id,
                            label: i.name
                        })
                    )
                );

                return new ApiResponseModel({ value: items });
            })
        );
    }
}
